module.exports = __webpack_public_path__ + "img/compilado-flexxs.92fabc59.svg";